import { isDate } from "util";
import { isString } from "ionic-angular/util/util";

/**
 *
 * if compareDates < 0 implies d0 < d1
 * if compareDates > 0 implies d0 > d1
 * if compareDates = 0 implies d0 === d1
 *
 * @param d0
 * @param d1
 */
export const compareDates = (d0: string | Date, d1: string | Date): number => {

    if (d0 && !d1) {
        return 1;
    } else if (!d0 && d1) {
        return -1;
    } else if (!d0 && !d0) {
        return 0;
    } else {
        const D0 = parseDate(d0);
        const D1 = parseDate(d1);
        return D0.valueOf() - D1.valueOf();
    }
};

const parseDate = (d: string | Date): Date => {

    if (isDate(d)) {
        return d as Date;
    } else if (isString(d)) {
        return new Date(d);
    } else {
        throw new Error("d is not an instance of string or Date");
    }
};



// WEBPACK FOOTER //
// ./src/core/util/compare-dates.ts